<template>
  <div class="noticeList">
    <el-table ref="multipleTable1" :data="noticeDataList" border tooltip-effect="dark" column-key="fileName" empty-text=""
      highlight-current-row height="100%" class="multipleTable1">
      <template slot="empty">
        <img :src="notNotice" alt="" />
        <p style="font-size:16px;">暂无数据</p>
      </template>
      <el-table-column type="index" width="50" label="序号" align="center"></el-table-column>
      <el-table-column prop="isOpen" label="是否公开" align="center" width="90">
        <template slot-scope="{ row }">
          <p v-if="row.isOpen==0" class="isOpen isNoOpenColoe">非公开</p>
          <p v-if="row.isOpen==1" class="isOpen isOpenColoe">公开</p>
        </template>
      </el-table-column>
      <el-table-column label="是否置顶" align="center" width="90">
        <template slot-scope="{ row }">
          <span v-if="row.isTop==1">置顶</span>
        </template>
      </el-table-column>
      <el-table-column v-if="isShow" label="是否阅读" align="center" width="110" sortable prop="isRead">
        <template slot-scope="{ row }">
          <div class="isReadBox">
            <p class="isRead" :class="row.isRead === 1 ? 'isReadBg' : 'isNoReadBg'"></p>
            <span :style="row.isRead === 1 ? 'color:#b5bed2' : 'color:var(--theme-color)'">{{ ['未阅读','已阅读'][row.isRead] }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column v-if="!isShow" show-overflow-tooltip label="公告状态" align="center" width="90">
        <template slot-scope="{ row }">
          <p v-if="row.isPublish == 2" class="disable">禁用</p>
          <p v-if="row.isPublish == 1" class="enable">启用</p>
          <p v-if="row.isPublish == 0" class="draft">草稿</p>
        </template>
      </el-table-column>
      <el-table-column prop="noticeTitle" label="标题" align="left" header-align="center" sortable>
        <template #default="{ row }">
          <el-link type="primary" @click="lookNotice(row)">
            <span class="tabLinkSpan" :title="row.noticeTitle">{{ row.noticeTitle }}</span>
          </el-link>
        </template>
      </el-table-column>
      <el-table-column show-overflow-tooltip prop="noticeAbstract" label="摘要" align="left" header-align="center" sortable>
      </el-table-column>
      <el-table-column v-if="name=='prj'" show-overflow-tooltip prop="prjName" label="项目名称" align="center" width="200" sortable></el-table-column>
      <el-table-column v-else show-overflow-tooltip prop="operateUserName" label="创建人" align="center" width="180" sortable></el-table-column>
      <el-table-column show-overflow-tooltip prop="createTime" label="创建时间" align="center" width="180" sortable></el-table-column>
      <el-table-column v-if="!isShow" label="操作" align="center" min-width="160px">
        <template slot-scope="{ row }">
          <div class="operation">
            <span v-if="row.isPublish==2&&noticeEnable" class="enable" @click.stop="disable(row,1)">启用</span>
            <span v-if="row.isPublish==1&&noticeDisable" class="disable" @click.stop="disable(row,2)">禁用</span>
            <span v-if="noticeEdit" class="edit" @click.stop="edit(row)">编辑</span>
            <span v-if="noticeDel" class="del" @click.stop="del(row)">删除</span>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div style="text-align:right" class="pagination">
      <page :page="page" @handleSizeChange="handleSizeChange" @handleCurrentChange="handleCurrentChange"></page>
    </div>
  </div>
</template>

<script>
import prjNoticeService from "@/CommonDP/service/prjNotice-service";
import sysNoticeService from "@/CommonDP/service/sysNotice-service";
import { checkPermission } from "@/CommonDP/utils/routeAuth";
import page from "@/CommonDP/components/paging";

export default {
  components: { page },
  props: {
    // 表格数据
    noticeDataList: {
      type: Array,
      required: true,
      default: () => []
    },
    lookNotice: {
      type: Function,
      required: true,
      default: () => {}
    },
    edit: {
      type: Function,
      required: false,
      default: () => {}
    },
    fetchData: {
      type: Function,
      required: true,
      default: () => {}
    },
    name: {
      type: String,
      required: true,
      default: () => ""
    },
    type: {
      type: String,
      required: false,
      default: () => ""
    },
    page: {
      type: Object,
      required: false,
      default: () => {}
    }
  },
  data() {
    return {
      notNotice: require("@/CommonDP/assets/workProjectBoard/notNotice.png") // 暂无公告
    };
  },
  computed: {
    noticeDisable() {
      return this.name === "prj" ? checkPermission(this.$allPerms.PRJNOTICE_DISABLE) : checkPermission(this.$allPerms.SYSNOTICE_DISABLE);
    },
    noticeEdit() {
      return this.name === "prj" ? checkPermission(this.$allPerms.PRJNOTICE_EDIT) : checkPermission(this.$allPerms.SYSNOTICE_EDIT);
    },
    noticeDel() {
      return this.name === "prj" ? checkPermission(this.$allPerms.PRJNOTICE_DEL) : checkPermission(this.$allPerms.SYSNOTICE_DEL);
    },
    noticeEnable() {
      return this.name === "prj" ? checkPermission(this.$allPerms.PRJNOTICE_ENABLE) : checkPermission(this.$allPerms.SYSNOTICE_ENABLE);
    },
    isShow() {
      return !!this.type;
    }
  },
  watch: {},
  created() {},
  methods: {
    del(row) {
      this.$confirm("确定删除吗？", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        customClass: "el-message-box"
      })
        .then(async () => {
          const ids = [row.noticeId];
          this.name === "prj" ? await prjNoticeService.prjNoticeDelete(ids) : await sysNoticeService.sysNoticeDelete(ids);
          this.$message.success("删除成功");
          this.fetchData(1);
        })
        .catch(() => {});
    },
    async disable(row, val) {
      let masTitle;
      val === 1 ? (masTitle = "确定要启用此条公告？") : (masTitle = "确定要禁用此条公告？");
      this.$confirm(`${masTitle}`, {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        customClass: "el-message-box"
      })
        .then(async () => {
          const formData = new FormData();
          formData.set("isPublish", val);
          formData.set("noticeId", row.noticeId);
          this.name === "prj" ? await prjNoticeService.prjNoticeDisable(formData) : await sysNoticeService.sysNoticeDisable(formData);
          let mas;
          val === 1 ? (mas = "启用成功") : (mas = "禁用成功");
          this.$message.success(`${mas}`);
          this.fetchData(1);
        })
        .catch(() => {});
    },
    handleSizeChange(val) {
      this.$emit('handleSizeChange', val);
    },
    handleCurrentChange(val) {
      this.$emit('handleCurrentChange', val);
    }
  }
};
</script>

<style lang="scss" scoped>
.noticeList {
  padding: var(--small-space) var(--big-space) 0;
  height: 100%;
  background: #fff;
  display: flex;
  flex-direction: column;
  .multipleTable1{
    height: 1px;
    flex-grow: 1;
  }
  .pagination {
    padding: var(--middle-space) 0;
    /deep/ .number {
      border: 1px solid #D9D9D9;
      background: none;
    }

    /deep/ .el-pager li.btn-quicknext, .el-pager li.btn-quickprev {
      border: 1px solid #D9D9D9;
      background: none;
    }

    /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
      border: 1px solid #1890FF;
      color: #1890FF;
      background: none;
    }

    /deep/ .btn-prev {
      border: 1px solid #D9D9D9;
      background: none;
    }

    /deep/ .btn-next {
      border: 1px solid #D9D9D9;
      background: none;
    }
  }
  .isOpen {
    width: 59px;
    height: 24px;
    border-radius: 3px;
    line-height: 24px;
    border: none;
    text-align: center;
    font-weight: 600;
    margin: 0 auto;
  }
  .isOpenColoe{
    background: #d9f4e0;
    color: #00b632;
  }
  .isNoOpenColoe{
    background: #fff0f0;
    color: #fb4242;
  }
  .isReadBox{
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .isRead{
    width: 6px;
    height: 6px;
    border-radius: 6px;
    margin-right: 4px;
  }
  .isReadBg {
    background: #b5bed2;
  }
  .isNoReadBg {
    box-shadow: 0px 0px 4px rgba(56, 111, 254, 0.79);
    background: var(--theme-color);
  }
  .enable {
    color: #12aaa3;
  }
  .del,.edit {
    color: var(--theme-color);
  }
  .disable {
    color: #ea3442;
  }
  .draft {
    color: #6a788c;
  }
  .operation{
    display: flex;
    justify-content: center;
    span{
      margin: 0 3px;
      cursor: pointer;
    }
  }
}
</style>
